export default __webpack_public_path__ + "static/media/skip-ad-arrow.1b5e2a25.svg";